'use strict';


import {parse_url, parse_str} from '../libs/tools';

var handler = function () {

};
var History = window.history;
var lastUrl = {hash: ''};


/**
 * 该事件只在浏览器中触发
 */
window.addEventListener("popstate", function (e) {
    var Url = parseUrl(window.location.href);
    var data = {};
    parse_str(Url.query, data);
    window.popstate && window.popstate(lastUrl.hash || Url.hash ? 0 : -1, Url.path, data);
    lastUrl = Url;
}, false);

/**
 * 解析url
 * @param url
 * @returns {*}
 */
function parseUrl(url) {
    var urlinfo = parse_url(url);
    urlinfo.path = urlinfo.path + (urlinfo.path.endsWith("/") ? "" : "/");
    return urlinfo;
}

/**
 *
 * @type {handler.pushState}
 */
window.pushState = handler.prototype.pushState = function (url = History.state.route, replace = false, flag = -1) {
    const Url = parseUrl(url);
    const Url2 = parseUrl(window.location.href);
    var data = {};
    if (Url.path === Url2.path || replace) {
        parse_str(Url.query, data);
        History.replaceState({route: url}, "", Url.path + (Url.query ? '?' + Url.query : ''));
        if (flag != -2)
            window.popstate && window.popstate(flag == -1 ? 0 : flag, Url.path, data);
    } else {
        //window.popstatecheck && window.popstatecheck(Url.path, function () {
        parse_str(Url.query, data);
        History.pushState({route: url}, "", Url.path + (Url.query ? '?' + Url.query : ''));
        if (flag != -2)
            window.popstate && window.popstate(flag == -1 ? 1 : flag, Url.path, data);
        //});
    }
};


/**
 * 返回上一个页面
 * @param data
 */
handler.prototype.goBack = function () {
    History.go(-1);
};

/**
 *
 * @returns {{}}
 */
var queryData = handler.prototype.queryData = function (key) {
    const Url = parse_url(window.location.href);
    var data = {};
    parse_str(Url.query, data);
    return data;
};

/**
 *
 * @returns {*}
 */
handler.prototype.getRoute = function () {
    var Url;
    Url = parseUrl(window.location.href);
    return Url.path;
}

/**
 *
 * @param msg
 */
handler.prototype.showMessage = function (msg) {
    console.log(msg);
    var str = "";
    for (var i in msg) {
        str += i + " : " + msg[i] + "<br/>";
    }
    return (str)
}

handler = new handler();
module.exports = handler;
